// const baseInfo = {
//  baseUrl:process.env.NODE_ENV === 'production' ? 'https://webapi2.test.goworkla.cn/' : 'https://webapi2.test.goworkla.cn/',
//  agentUrl: process.env.NODE_ENV === 'production' ? 'http://agent.test.goworkla.cn/' : 'http://agent.test.goworkla.cn/',
// }
// 
// 预览
// const baseInfo = {
//  baseUrl:"https://apitest.goworkla.cn",
//  agentUrl: "https://agentest.goworkla.cn",
// }

// const baseInfo = {
//     baseUrl: "http://192.168.0.120:801",
//     agentUrl: "http://192.168.0.120:802",
// }

// const baseInfo = {
//     baseUrl: "https://webapi2.test.goworkla.cn/",
//     agentUrl: "https://agentnew.test.goworkla.cn/",
// }

// const baseInfo = {
    // baseUrl: "https://webapi3.test.goworkla.cn/",
    // agentUrl: "https://agentnew.test.goworkla.cn/",
// }

// const baseInfo = {
//     baseUrl: "https://webapi.goworkla.cn/",
//     agentUrl: "https://agent.goworkla.cn/",
// }

const baseInfo = {
    baseUrl: "https://webapi.goworkla.cn",
    // baseUrl: "https://apinet6.goworkla.cn",
    agentUrl: "https://agentnew.goworkla.cn",
}

export default baseInfo